import React, { useContext } from "react";
import CaseWebsiteContext from "../context/websitecontext";
import Paper from "@material-ui/core/Paper";
import {
  Policy,
  BusinessCenter,
  Gavel,
  PhoneAndroid,
  Mail,
} from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";

import { makeStyles } from "@material-ui/core/styles";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import { ICaseData } from "../types";
import { useTranslation } from "react-i18next";
interface IInformationCard {
  showAddress?: boolean;
}

const useStyles = makeStyles({
  root: {
    margin: "1em",
    padding: "1em",
  },
  padding: {
    padding: "1em",
  },
});

const useToolTipStyles = makeStyles({
  tooltip: {
    fontSize: "0.8rem",
  },
});
const InformationCard: React.FC<IInformationCard> = ({ showAddress }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const toolTipClasses = useToolTipStyles();
  const context = useContext<ICaseData>(CaseWebsiteContext);

  const {
    CaseMetaData,
    OfficialCaseName,
    CourtTitle,
    CourtAssignedCase,
    CasePhoneNumber,
  } = context.data;
  const { WebId } = CaseMetaData;

  const officialCaseNameTooltip = t("Official Case Name");
  const courtTitleTooltip = t("Court Title");
  const caseNumberTooltip = t("Case No");
  const phoneNumberTooltip = t("Phone");
  return (
    <Paper className={classes.root}>
      <Typography color="primary" variant="h5">
        {t("Case Information", "us")}
      </Typography>
      <Divider />

      <List dense>
        <ListItem>
          <ListItemIcon>
            <BusinessCenter />
          </ListItemIcon>
          <ListItemText>
            <Tooltip
              classes={toolTipClasses}
              title={officialCaseNameTooltip}
              placement="right"
            >
              <Typography component="span">{OfficialCaseName}</Typography>
            </Tooltip>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Policy />
          </ListItemIcon>
          <ListItemText>
            <Tooltip classes={toolTipClasses} title={courtTitleTooltip} placement="right">
              <Typography component="span">{CourtTitle}</Typography>
            </Tooltip>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Gavel />
          </ListItemIcon>
          <ListItemText>
            <Tooltip classes={toolTipClasses} title={caseNumberTooltip} placement="right">
              <Typography component="span">{CourtAssignedCase}</Typography>
            </Tooltip>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <PhoneAndroid />
          </ListItemIcon>
          <ListItemText>
            <Tooltip classes={toolTipClasses} title={phoneNumberTooltip} placement="right">
              <Typography component="span">{WebId !== "c17cb45e-a7a2-48c4-b387-41694ef4e916" ? CasePhoneNumber : "(310) 277-0010"}</Typography>
            </Tooltip>
          </ListItemText>
        </ListItem>
        {showAddress && WebId !== 'da457c68-6641-4815-b109-742461b54647' && (
          <ListItem>
            <ListItemIcon>
              <Mail />
            </ListItemIcon>
            <ListItemText>

              <>{WebId !== 'c17cb45e-a7a2-48c4-b387-41694ef4e916' &&<Typography>{
                WebId === '5faebc3f-ac70-4cce-8fea-73924040e0ec'
                  || WebId === '9c28ac25-e4d3-4560-bad7-d3179f1736f0'
                  || WebId === 'a0b61cb4-b7b7-43e4-af10-317b54a1c7c3'
                  || WebId === '41aef4c8-5e7f-4298-a0a3-370b93bb6446' ?
                  'Notice Administrator'
                  : WebId === '8ac8d083-d4ea-4ffc-a53a-b65bf17d8dd3' ? 'Administrator' : 'Settlement Administrator'}</Typography>}</>
              {WebId !== 'c17cb45e-a7a2-48c4-b387-41694ef4e916' && <Typography>{OfficialCaseName}</Typography>}
              {
                WebId !== 'c17cb45e-a7a2-48c4-b387-41694ef4e916' ?
                <><Typography>c/o Simpluris, Inc.</Typography>
              <Typography>P.O. Box 26170, Santa Ana, CA 92799</Typography></>
              : <>
              <Typography>PETER LAW GROUP</Typography>
              <Typography>270 Coral Circle</Typography>
              <Typography>El Segundo, CA  90245</Typography>
             
              </>}
            </ListItemText>
          </ListItem>
        )}
      </List>
    </Paper>
  );
};

export default React.memo(InformationCard);
